module.exports = __webpack_public_path__ + "static/media/4.a43e1af1.png";